module.exports = __webpack_public_path__ + "img/29_57.a76bada9.png";